import React, { Fragment } from 'react';
import { Modal, Typography, List, Divider } from 'antd';

const { Title, Text } = Typography;

const UnprocessedOrdersModal = ({ visible, onClose, data }) => {

  const error= {
    invalid_lh_transfer_order: `Please complete the related Line haul order`,
    coordinates_are_missing: `Coordinates are missing`,
    assigned_to_other_route: `Assigned to other route`,
    invalid_appointment: `Invalid appointment`,
  }
  return (
    <Fragment
    >
      {data.map((item) => (
        <div key={item.type} style={{ marginBottom: 24 }}>
          <h4>
           {error[item.type]}
          </h4>

          {(item.orders?.length || item.order_ids?.length) ? (
            <>
              {item.orders?.length > 0 && (
                <>
                  <Text strong>Orders:</Text>
                <p style={{ paddingLeft: 10}}>{item.orders.join(', ')}</p>
                </>
              )}
            </>
          ) : (
            <Text type="secondary">No orders in this category.</Text>
          )}

          <Divider />
        </div>
      ))}
    </Fragment>
  );
};

export default UnprocessedOrdersModal;
